<template>
  <el-dialog
    title="选择打开方式"
    :visible.sync="show"
    :lock-scroll="false"
    center
    width="560px"
  >
    <div style="text-align: center">
      <el-button
        type="primary"
        round
        style="width: 120px; margin-right: 70px"
        @click="openWeb"
      >
        网页
      </el-button>
      <el-button type="primary" round style="width: 120px" @click="openClient">
        客户端
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "LiveSelect",
  props: {
    openByWeb: {
      type: Function,
    },
    openByClient: {
      type: Function,
    },
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    openWeb() {
      this.openByWeb && this.openByWeb();
      this.show = false;
    },
    openClient() {
      this.openByClient && this.openByClient();
      this.show = false;
    },
  },
};
</script>
